import WebsiteBehaviors from "../website-behaviors/index.js";
import {injectScript} from "../utils/document.js";
import DOMPurify from "dompurify";

class Bloomberg extends WebsiteBehaviors {
	identifier() {
		return "Bloomberg";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "bloomberglaw.com" || location.host.endsWith(".bloomberglaw.com"));
	}

	styles() {
		// language=CSS
		return `
			#copyWithCitationButton {
				display: none !important;
			}
		`;
	}

	getCopyButtonLabel() {
		return "Copy With Citation";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'selectedText' implicitly has an 'any' t... Remove this comment to see the full error message
	async copySelectionToClipboard(selectedText, document, loadCitation) {
		/* eslint-disable */
// @ts-expect-error TS(7006) FIXME: Parameter 'selectedText' implicitly has an 'any' t... Remove this comment to see the full error message
		injectScript(document, function (selectedText) {
// @ts-expect-error TS(2304) FIXME: Cannot find name 'PopupUtils'.
			PopupUtils.renderElementInPopup('#copyWithCitationPopupContents');
// @ts-expect-error TS(2304) FIXME: Cannot find name 'replaceWithMsLinks'.
			let selectionContent = replaceWithMsLinks(selectedText),
				chrome = /chrom(e|ium)/.test(navigator.userAgent.toLowerCase());
			chrome && selectionContent.length && (selectionContent = selectionContent.replace(/ <span/g, '&nbsp;<span')),
				document.querySelector('#popupWindow .copyWithCitationText').innerHTML = DOMPurify.sanitize(selectionContent),
// @ts-expect-error TS(2304) FIXME: Cannot find name 'removeJSLinks'.
				removeJSLinks(),
// @ts-expect-error TS(2304) FIXME: Cannot find name 'removeFormElements'.
				removeFormElements(),
// @ts-expect-error TS(2304) FIXME: Cannot find name 'createCopyWithCitationLink'.
				createCopyWithCitationLink(),
				document.querySelector('#popupWindow .copyWithCitationArea').select(),
// @ts-expect-error TS(2304) FIXME: Cannot find name 'trackCopyWithCite'.
				trackCopyWithCite(document.querySelector('#popupWindow .copyWithCitationDocumentTitle a').innerText);
// @ts-expect-error TS(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
		}, [selectedText]);
		/* eslint-enable */

		super.copySelectionToClipboard(selectedText, document, null);
	}
}

export default Bloomberg;
